// extracted by mini-css-extract-plugin
export default {"userInfo":"OrderDetailView_userInfo__XeTAh"};